module.exports = __webpack_public_path__ + "static/media/film.7ab098f5.svg";